import ajax from './ajax';

/* eslint-disable import/prefer-default-export */
export function cancelSubscription(data) {
  return ajax('/resources/cancel-subscription/', { method: 'POST', data });
}